export default class Topic {
    device = {
        serviceCallback: "",
        eventReport: ""
    }
    server = {
        serviceCall: ""
    }
}


